import './index.css';
import { useMemo } from 'react';

const WechatCode: React.FC<{onClose: ()=> void, data: any}> = (props) => {
    const {onClose,  data = {} } = props
    const { payType } = data
    const type = useMemo(() => payType === 'image_pay' ? 2 : 1, [payType])
    // const codeUrl = 'https://game-dev-1251139535.cos.ap-shanghai.myqcloud.com/payAndShareIcon/1_1007174567_171_85_3_795573857_580b37aba003b29e4b386589d820b499.png'
    const conMapPayType: {[key: number]: any} = {
        1: {
            title: '请前往公众号支付',
            con1: '1、长按二维码',
            con2: '2、公众号点击充值',
            con3: '3、付款并回到游戏'
        },
        2: {
            title: '微信扫码支付',
            con1: '1、截屏将图片保存至手机',
            con2: '2、使用微信“扫一扫”识别二维码',
            con3: '3、付款并回到游戏'
        },
    }
    return (
        <div className="wrapWechat">
            <div className='wechatTitle'>
                <div className='wechatTitleContent'>{conMapPayType[type].title}</div>
                <div className='wechatClose' onClick={onClose}></div>
            </div>
            <div className="wechatBox">
                <img src={data?.codeUrl} alt="" />
            </div>
            <div className='wechatTips'>{conMapPayType[type].con1}</div>
            <div className='wechatTips'>{conMapPayType[type].con2}</div>
            <div className='wechatTips'>{conMapPayType[type].con3}</div>
        </div>)
}



export default WechatCode;
